import React, { Fragment } from 'react'
import classes from './Inputs.module.css'
import CheckRoundedIcon from '@mui/icons-material/CheckRounded'
const Checkbox = ({
  other,
  active,
  children,
  description,
  className = '',
  containerClassName = '',
  value,
  onClick = () => {},
  onChange
}) => {
  return (
    <Fragment>
      <div className={`${classes.flexColumn} ${classes.fullWidth} ${containerClassName}`}>
        <div
          className={`${classes.flexRow} ${classes.fullWidth}`}
          onClick={onClick}
        >
          <div
            className={`${classes.checkbox} ${
              active ? classes.checkedActive : null
            } ${className}`}
          >
            {active && <CheckRoundedIcon />}
          </div>
          <div>
            <p className={classes.checkboxText}>{children}</p>
            {active && description && (
              <p className={classes.checkboxTextDescription}>{description}</p>
            )}
          </div>
        </div>

        {other && active && (
          <div>
            <input
              placeholder="Menciona Cual"
              onChange={onChange}
              value={value}
              className={classes.inputOther}
            />
          </div>
        )}
      </div>
    </Fragment>
  )
}

export default Checkbox
